// Network and chain types — frozen, immutable domain data

export type ChainFamily = 'evm' | 'utxo' | 'solana' | 'tron' | 'xrp' | 'ton' | 'sui';

export type NetworkId =
  | 'bitcoin' | 'litecoin'
  | 'ethereum' | 'polygon' | 'arbitrum' | 'optimism' | 'base' | 'bsc' | 'avalanche' | 'hyperevm'
  | 'solana' | 'tron' | 'xrp' | 'ton' | 'sui';

export type Explorer = Readonly<{
  readonly baseUrl: string;
  readonly txPath: string;
  readonly addressPath: string;
}>;

export type Network = Readonly<{
  readonly id: NetworkId;
  readonly name: string;
  readonly chainFamily: ChainFamily;
  readonly chainId: number;
  // ENS address-record coinType: SLIP-44 for non-EVM + Ethereum (60); ENSIP-11 (0x80000000 + chainId) for other EVM chains
  readonly coinType: number;
  readonly nativeDecimals: number;
  // Symbol of the network's own (gas) coin, e.g. POL on Polygon — even where it isn't a payment coin
  readonly nativeSymbol: string;
  readonly explorer: Explorer;
  readonly publicRpcEnvKey: string;
  readonly iconPath: string;
  readonly isActive: boolean;
  // When false, the network is excluded from standalone Send flow (no fee smart contract).
  // Still available in Request/Scan flows where a merchant or payment request initiates the transaction.
  readonly allowSend: boolean;
}>;

export const CHAIN_FAMILY_FOR_NETWORK: Readonly<Record<NetworkId, ChainFamily>> = Object.freeze({
  bitcoin: 'utxo',
  litecoin: 'utxo',
  ethereum: 'evm',
  polygon: 'evm',
  arbitrum: 'evm',
  optimism: 'evm',
  base: 'evm',
  bsc: 'evm',
  avalanche: 'evm',
  hyperevm: 'evm',
  solana: 'solana',
  tron: 'tron',
  xrp: 'xrp',
  ton: 'ton',
  sui: 'sui',
});
